export enum TYPE_USER {}
export enum USER_STATES {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum ROLE_USER {
  STANDARD = "STANDARD",
}

export interface User {
  _id: string;
  firstName: string;
  lastName: string;
  phone: string;
  type: string;
  height?: number;
  weight?: number;
  dateOfBirth?: Date;
  email: string;
  image?: string;
  status: string;
  role: ROLE_USER;
  createdAt: number;
  updatedAt: number;
  coach: string;
  active?: boolean;
  bodyComposition: string[];
}
